import { Account } from 'src/models';

import { useAccountSelector } from './useAccountSelector';
import { useAuthenticatedUserSelector } from './useAuthenticatedUserSelector';

export const useFindOtherAccountList = (): Account[] => {
  const { user } = useAuthenticatedUserSelector();
  const { account } = useAccountSelector();

  const allAccounts = user?.accounts.concat(user.accountLinks) ?? [];

  return allAccounts.filter(acc => acc.id !== account?.id);
};
